import CelMoney from "@/components/functionals/CelMoney";
import RenderCheckLabel from "@/components/functionals/RenderCheckLabel";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ContractConditioColors from "@/components/CutAndReconection/ContractConditioColors.vue";

export default (thiss) => [
  {
    prop: "full_name",
    label: "Nombre Cliente",
    fixed: true,
    "class-name": "stickyColumn",
    minWidth: 300,
    sortable: true
  },
  {
    prop: "id",
    name: "NO",
    label: "Navixy Id",
    minWidth: 110,
    sortable: true
  },
  {
    prop: "activated",
    label: "Estado Navixy",
    minWidth: 140,
    sortable: true,
    formatter: RenderCheckLabel
  },
  {
    prop: "reason",
    name: "Razon",
    label: "Motivo de Corte",
    //fixed: true,
    "class-name": "stickyColumn1",
    minWidth: 150,
    sortable: true
  },
  {
    prop: "InvoiceQty",
    label: "Facturas Pendientes",
    align: "center",
    minWidth: 180,
    sortable: true
  },
  {
    prop: "DebtAmount",
    label: "Saldo Pendiente",
    align: "center",
    minWidth: 150,
    sortable: true,
    formatter: CelMoney
  },

  {
    prop: "contractCondition",
    label: "Condicion de Contrato",
    align: "center",
    //fixed: true,
    "class-name": "stickyColumn2",
    minWidth: 190,
    sortable: true,
    // formatter: ContractConditioColors,
    formatter: (row, column, rowvalue) => {
      const createElement = thiss.$createElement;
      return createElement(ContractConditioColors, {
        props: {
          rowvalueId:
            rowvalue === "Abierto" ? 0 : row.activated === true ? 2 : 1,
          rowvalue: rowvalue,
          row: row,
          column: column
        }
      });
    }
  },

  {
    prop: "tipocontrato",
    label: " Tipo Contrato",
    align: "center",
    //fixed: true,
    "class-name": "stickyColumn3",
    minWidth: 150,
    sortable: true
  },
  {
    prop: "post_region",
    label: "Codigo Navition",
    align: "center",
    //fixed: true,
    "class-name": "stickyColumn4",
    minWidth: 150,
    sortable: true
  },
  {
    prop: "trackers_count",
    label: "Cantidad de GPS",
    align: "center",
    minWidth: 160,
    sortable: true
  },

  {
    prop: "daysInactive",
    label: "Disas desactivados",
    align: "center",
    minWidth: 170,
    sortable: true
  },
  {
    prop: "update_date",
    label: "Fecha de corte",
    minWidth: 150,
    sortable: true,
    attrs: {
      onlyDate: true
    },
    formatter: DatetimeFormatter
  }
];
